import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentSpacePersonLite on SpacePerson {
    id
    code
    description
    firstName
    lastName
    name
  }
`

export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentSpacePersonLiteFragment,
  ents.extra.space.Person
>({
  code: transformers.PASS_THROUGH,
  description: transformers.PASS_THROUGH,
  firstName: transformers.PASS_THROUGH,
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.space.Person.Id.isId,
  ),
  lastName: transformers.PASS_THROUGH,
  name: transformers.PASS_THROUGH,
})
